<template>

    <div class="">
        <!-- Summary -->
        <div class="row">
            <div class="col-md-12">
                <div class="input-group flex-nowrap p-1 border-0 border-start" :class="[light.border]" style="cursor: default;">
                    <div class="btn me-1" :class=[light.text,light.border,light.back] style="align-items: center; display:flex; width: 25%">
                        <i class="fa-solid text-primary fa-server me-2" style="font-size: 25px;"></i>
                        <div class="w-100 text-start fw-light fs-4">
                            Devices
                        </div>
                    </div>
                    <div class="btn me-1" :class="[light.text, light.back, light.border]" title="Connected devices." style="width: 25%;">
                        <div class="fa-solid text-success fa-circle-check" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{connected}}
                        </div>
                    </div>
                    <div class="btn me-1" :class="[light.text, light.back, light.border]" title="Disconnected devices." style="width: 25%;">
                        <div class="fa-solid text-danger fa-circle-xmark" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{disconnected}}
                        </div>
                    </div>
                    <div class="btn" :class=[light.text,light.border,light.back] title="Total devices." style="width: 25%;">
                        <div class="fa-solid fa-t" style="font-size: 20px;"></div>
                        <div class="w-100">
                             {{ total }}
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Countries, Map & Disconnected Sites. -->
        <div class="row mt-3">
            <div class="col-md-12">
                <div class="text-start fw-light fs-4 mb-1" :class="[light.text]" style="letter-spacing: 3px;">
                    <i class="fa-solid fa-globe text-primary"></i>
                    Geolocation
                </div>
                <div class="rounded" :class="[light.border]" style="height: 230px;">
                    <SiteMap :key="mapSettings.key" :mapkey="mapkey" mapHeight="230" :mapSettings="mapSettings"
                        :markers="markers" :icons="icons" />
                </div>


                <div class="text-start fs-4 fw-light" :class="[light.text]" style="letter-spacing: 3px; margin-top: 30px;">
                    <i class="fa-solid fa-circle-xmark text-danger"></i>
                    Disconnected Sites {{ `(${disconnected})` }}
                </div>

                <div class="rounded" style="width: 100%;">
                    <div class="table-responsive" :class="[light.border]" style="overflow:auto;">
                        <table class="table table-sm table-hover mb-0">
                            <thead class="table_header" >
                                <tr>
                                    <th>Alias</th>
                                    <th>Client</th>
                                    <th>Cloud</th>
                                    <th>Device OS</th>
                                    <th>Hostname</th>
                                    <th>ID cloud</th>
                                    <th>IP</th>
                                    <th>MAC</th>
                                    <th>OS version</th>
                                    <th>Product_type</th>
                                    <th>Site</th>
                                    <th>Status</th>
                                    <th>Date time</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(ds, index) in sites_down" :key="index" :class="[light.header, light.text]">
                                    <td>{{ ds.alias }}</td>
                                    <td>{{ ds.client }}</td>
                                    <td>{{ ds.cloud }}</td>
                                    <td>{{ ds.device_os }}</td>
                                    <td>{{ ds.hostname }}</td>
                                    <td>{{ ds.id_cloud }}</td>
                                    <td>{{ ds.ip }}</td>
                                    <td>{{ ds.mac }}</td>
                                    <td>{{ ds.os_version }}</td>
                                    <td>{{ ds.product_type }}</td>
                                    <td>{{ ds.site }}</td>
                                    <td>
                                        <span class="badge" :class="{
                                            'bg-success': ds.status === 'up',
                                            'bg-danger': ds.status === 'down',
                                            'bg-secondary': !['up', 'down'].includes(ds.status)
                                        }">
                                            {{ ds.status }}
                                        </span>
                                    </td>
                                    <td>{{ timestamp }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="text-start fs-4 fw-light" :class="[light.text]" style="letter-spacing: 3px; margin-top: 30px;">
                    <i class="fa-solid fa-circle-check text-success"></i>
                    Connected Sites {{ `(${connected})` }}
                </div>

                <div class="rounded" style="width: 100%;">
                    <div class="table-responsive" :class="[light.border]" style="overflow:auto;">
                        <table class="table table-sm table-hover mb-0">
                            <thead class="table_header" >
                                <tr>
                                    <th>Alias</th>
                                    <th>Client</th>
                                    <th>Cloud</th>
                                    <th>Device OS</th>
                                    <th>Hostname</th>
                                    <th>ID cloud</th>
                                    <th>IP</th>
                                    <th>MAC</th>
                                    <th>OS version</th>
                                    <th>Product_type</th>
                                    <th>Site</th>
                                    <th>Status</th>
                                    <th>Date time</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(ds, index) in sites_up" :key="index" :class="[light.header, light.text]">
                                    <td>{{ ds.alias }}</td>
                                    <td>{{ ds.client }}</td>
                                    <td>{{ ds.cloud }}</td>
                                    <td>{{ ds.device_os }}</td>
                                    <td>{{ ds.hostname }}</td>
                                    <td>{{ ds.id_cloud }}</td>
                                    <td>{{ ds.ip }}</td>
                                    <td>{{ ds.mac }}</td>
                                    <td>{{ ds.os_version }}</td>
                                    <td>{{ ds.product_type }}</td>
                                    <td>{{ ds.site }}</td>
                                    <td>
                                        <span class="badge" :class="{
                                            'bg-success': ds.status === 'up',
                                            'bg-danger': ds.status === 'down',
                                            'bg-secondary': !['up', 'down'].includes(ds.status)
                                        }">
                                            {{ ds.status }}
                                        </span>
                                    </td>
                                     <td>{{ timestamp }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
    // @ is an alias to /src
    import SiteMap from '@/components/apps-components/integrations/customers/stage/deps/SiteMap.vue'

    import axios from "axios";

    export default {
        name: 'Level2',
        props: {
            site: String,
            light: Object,
            mapkey: String
        },
        components: {
            SiteMap
        },
        data() {
            return {
                source: "fortigate-level-2",
                loading: false,
                maindata: [],
                mapSettings: {
                    key: 1,
                    centerLat: 23.6345,
                    centerLon: -102.5528,
                    zoom: 4,
                    theme: 'dark'
                },
                icons: {
                    good: { path: require("@/assets/icons/check.png"), size: [20, 20], anchor: [10, 10] },
                    bad: { path: require("@/assets/icons/fail.png"), size: [20, 20], anchor: [10, 10] },
                    fair: { path: require("@/assets/icons/fair.png"), size: [20, 20], anchor: [10, 10] }
                },
                // Filtering
                timestamp: null
            }
        },
        methods: {
            getMaindata() {
                this.loading = true
                const params = { source: `${this.source}` }
                const dest = this.site + '/integrations/fortigate/data'
                axios
                    .get(dest, { params })
                    .then(rx => {
                        // Code
                        this.maindata = rx.data.response.data.summary
                        this.timestamp = rx.data.response.timestamp
                        this.markers = rx.data.response.data.summary.map(site => ({
                            ...site,
                            coords: [
                                parseFloat(site.latitude),
                                parseFloat(site.longitude)
                            ],
                            "country": "Mexico",
                            "icon": site.status === "up" ? "good" : "bad",
                            "providers": [{...site}]
                        }))
                        this.loading = false
                        this.stopLoading()
                    })
                    .catch(error => {
                        //this.processErrorMessage(error)
                        this.loading = false
                        this.stopLoading()
                    });
            },
            stopLoading() {
                this.$emit('clear-loading-lv2', this.timestamp);
            },
            titlelize(_string) {
                return _string.toLowerCase()
                    .split('-')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join('-');
            },
            renderMap() {
                this.mapSettings.theme = this.light.theme
                this.mapSettings.key += 1;
            }
        },
        computed: {
            sites_up() {
                return this.maindata.filter(element => element.status === "up")
            },
            sites_down() {
                return this.maindata.filter(element => element.status === "down")
            },
            connected(){
                return this.sites_up.length;
            },
            disconnected(){
                return this.sites_down.length;
            },
            total(){
                return this.connected + this.disconnected;
            }
        },
        created: function () {
            // Code
        },
        mounted: function () {
            // Code
        }


    }
</script>

<style scoped>

    .stage-main-color {
        color: rgb(91, 152, 188);
    }

    .back-darker {
        background-color: rgb(49, 49, 49);
    }

    .border-bottom-light-grey {
        border-bottom: solid rgb(32, 32, 32) 1px
    }

    .bg-bar {
        background-color: rgb(241, 175, 61);
    }

    .table {
        font-size: 12px;
        white-space: nowrap;
        text-align: left;
    }

    .table th {
        font-size: 15px;
        font-weight: 600;
    }

    .table td {
        font-size: 10px;
        vertical-align: middle;
    }

    .table-hover tbody tr:hover {
        background-color: #96abc9 !important;
    }

    .table-hover tbody tr:hover td {
        color: #ffffff !important;
    }

    .sticky-top {
        z-index: 10;
    }

    .table_header{
        color:cornflowerblue !important;
    }

</style>